import { Toast } from 'components/stores/toaster';

export const layoutToggleSuccess = (): Toast => ({
  icon: 'success',
  heading: 'Switched to new layout',
  text: 'You can still disable it in Permissions block.'
});
